<script lang="ts">
	import { page } from '$app/stores';
	import ArrowRight from '$lib/assets/images/icons/arrow-right-dark.svg?component';
	import HelpIcon from '$lib/assets/images/icons/help.svg?component';
	import __ from '$lib/stores/TranslationStore';
</script>

<a
	href="{$page.data?.location?.origin}/contacto"
	class="flex w-full flex-col divide-y-[1px] divide-split overflow-hidden rounded-xl bg-light text-dark md:flex-row md:divide-x-[1px] md:divide-y-0 lg:h-[460px] lg:flex-col lg:divide-x-0 lg:divide-y-[1px] lg:rounded-3xl"
>
	<div
		class="items-left flex flex-col gap-2 px-20 py-8 md:flex-row md:gap-x-8 md:px-10 md:py-7 lg:h-full lg:flex-col lg:justify-center lg:px-20 lg:py-8"
	>
		<div class="md:self-center lg:self-auto">
			<HelpIcon class="h-8 w-8 md:h-16 md:w-16 lg:h-8 lg:w-8" />
		</div>
		<div class="space-y-2">
			<h3 class="mt-2 text-xs font-semibold uppercase tracking-0.14 text-primary">
				{$__('Simuladores')}
			</h3>
			<h2 class="mt-2 text-2xl font-semibold">{$__('Em dúvida sobre qual simulador utilizar?')}</h2>
			<p style="opacity: 70%;" class="text-sm opacity-[20%]">
				{$__('Fale com um dos nossos consultores!')}
			</p>
		</div>
	</div>
	<div
		class="flex items-center justify-center gap-4 p-4 md:w-40 md:shrink-0 md:grow-0 md:flex-col lg:w-auto lg:shrink lg:flex-row"
	>
		<p class="font-semibold md:whitespace-nowrap">{$__('Contactar')}</p>
		<ArrowRight class="fill-dark md:order-first lg:order-last" />
	</div>
</a>
